/**
 * A paleta do Dev Board — as mesmas cores das colunas semeadas.
 *
 * <p>Coluna e tag pescam dela por ciclo (`CORES[quantidade % CORES.length]`) para nascer
 * com uma cor sem perguntar: ninguém escolhe cor na hora de criar, só depois, se quiser.
 */
export const CORES = [
  '#8E8875', '#5B8FB9', '#C9A25A', '#A87BD0', '#B04A45',
  '#4E9C6B', '#C0703C', '#3FA0A0', '#8E7CC3', '#A9C46C',
];
